var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:_vm.size ? `loader-${_vm.size}` : ''},[_c('div',{staticClass:"loading-circle",class:[_vm.color ? _vm.color : ''],style:(_vm.cssVars)},[_c('div',{staticClass:"fixed-circle"}),_c('div',{staticClass:"rotating-section"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }